// NgRX
import { createActionGroup, props } from '@ngrx/store';

// Models
import {
  Depreciation,
  DepreciationStatus,
  FirstStepStatus, History, Tab,
  ThirdStepStatus, ToolsErrors
} from '@core/models/depreciation.interface';
import { filter } from 'rxjs';


// Depreciation
export const DepreciationEffectsActions = createActionGroup({
  source: 'API Depreciation',
  events: {
    'reset store': props<any>(),
    'get store': props<any>(),
    'inject store': props<{ depreciation: Depreciation }>(),
    'update store': props<{ status: DepreciationStatus }>(),
    'cancel depreciation': props<any>(),
    'finalize depreciation': props<any>(),
    'inject id': props<{ id: number }>(),
    'inject error': props<{ error: any }>(),
  },
});

export const DepreciationStepperActions = createActionGroup({
  source: 'Stepper',
  events: {
    'next': props<any>(),
    'previous': props<any>(),
    'first': props<any>(),
    'last': props<any>(),
    'select': props<{ step: number }>(),
  },
});

// First step
export const DepreciationFirstStepActions = createActionGroup({
  source: 'First step',
  events: {
    'open range picker dialog': props<any>(),
    'close range picker dialog': props<any>(),
    'open confirm date dialog': props<any>(),
    'close confirm date dialog': props<any>(),
    'inject period': props<{ period: { from: string, to: string }}>(),
  },
});

export const DepreciationFirstStepEffectsActions = createActionGroup({
  source: 'API First step',
  events: {
    'get store insteand of init lost events': props<any>(),
    'inject store insteand of init lost events': props<{ currentStatus: string }>(),
    'get history': props<any>(),
    'inject history': props<{ history: History }>(),
    'init lost events': props<{ period: { from: string, to: string }}>(),
    'inject event missed': props<{ period: { from: string, to: string }}>(),
    'inject error': props<{ error: any }>(),
    'connect lost events load socket': props<any>(),
    'inject lost events load socket': props<{ socket: { percentage: number, status: string }}>(),
    'disconnect lost events load socket': props<{ isCancelled: boolean }>(),
    'cancel lost events load socket': props<any>(),
  },
});


// Second step
export const DepreciationSecondStepActions = createActionGroup({
  source: 'Second step',
  events: { },
});

export const DepreciationSecondStepEffectsActions = createActionGroup({
  source: 'API Second step',
  events: {
    'send file': props<{ file: File | null }>(),
    'inject file': props<{ file: File | null }>(),
    'inject error': props<{ error: { errorMessage: any, rowsWithProblems: any }}>(),
  },
});


// Third step
export const DepreciationThirdStepActions = createActionGroup({
  source: 'Third step',
  events: {
    'cancel depreciation': props<any>(),
  },
});

export const DepreciationThirdStepEffectsActions = createActionGroup({
  source: 'API Third step',
  events: {
    'send file': props<{ file: File | null }>(),
    'inject file': props<{ file: File | null }>(),
    'inject error': props<{ error: { errorMessage: any, rowsWithProblems: any }}>(),
    'connect caf load socket': props<any>(),
    'inject caf load socket': props<{ socket: { percentage: number, status: string }}>(),
    'disconnect caf load socket': props<{ isCancelled: boolean }>(),
    'cancel caf load socket': props<any>(),
  },
});


// Skip events step
export const DepreciationSkipEventsStepActions = createActionGroup({
  source: 'Skip events step',
  events: {
    'select tab': props<{ selected: Tab }>(),
  },
});

export const DepreciationSkipEventsStepEffectsActions = createActionGroup({
  source: 'API Skip events step',
  events: {
    'get skip events': props<{ skip: boolean, eventType: any, filter: any, search: string, page: number, limit: number }>(),
    'inject skip events': props<{ events: { tools: any[], length: number }, params: any }>(),
    'set skip event': props<{ tool: any, eventType: any, by: any }>(),
    'inject skip event': props<{ event: any }>(),
    'export skip events': props<{ skip: boolean, eventType: any }>(),
    'inject error': props<{ error: any }>(),
  },
});


// Fourth Step
export const DepreciationFourthStepActions = createActionGroup({
  source: 'Fourth step',
  events: {
    'select tab': props<{ selected: Tab }>(),
    'change page': props<{ current: number }>(),
    'filter by': props<{ typeSearch: string, search: string, typeError: string }>(),
  },
});

export const DepreciationFourthStepEffectsActions = createActionGroup({
  source: 'API Fourth step',
  events: {
    'get registered tools errors': props<any>(),
    'get unregistered tools errors': props<any>(),
    'correct registered tool': props<{ id: number, corrections: any }>(),
    'correct unregistered tool': props<{ id: number, corrections: any }>(),
    'reprocess all registered tools': props<{ ids: number[] }>(),
    'reprocess all unregistered tools': props<{ ids: number[] }>(),
    'reprocess registered tool': props<{ id: number }>(),
    'remove registered tool': props<{ id: number }>(),
    'remove unregistered tool': props<{ id: number }>(),
    'reprocess unregistered tool': props<{ id: number }>(),
    'inject registered tools errors': props<{ toolsErrors: ToolsErrors }>(),
    'inject unregistered tools errors': props<{ toolsErrors: ToolsErrors }>(),
    'inject error': props<{ error: any }>(),
  },
});

// Fifth Step
export const DepreciationFifthStepActions = createActionGroup({
  source: 'Fifth step',
  events: { },
});

export const DepreciationFifthStepEffectsActions = createActionGroup({
  source: 'API Fifth step',
  events: {
    'download report file': props<{ fileType: string }>(),
    'send report': props<any>(),
    'inject error': props<{ error: any }>(),
  },
});
//#endregion
